exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._34rMT1fP_ivu4l_SSEyaOC{color:\"[theme:themePrimary, default:#0078D4]\"}html[dir=ltr] ._34rMT1fP_ivu4l_SSEyaOC{margin-left:0}html[dir=rtl] ._34rMT1fP_ivu4l_SSEyaOC{margin-right:0}html[dir] ._3hNknJhQ7N3OOQOQdSheN0:hover{background:transparent}._1upOrGDy4pVpvaMC9y7z5o{width:0}", ""]);

// exports
exports.locals = {
	"moreLabel": "_34rMT1fP_ivu4l_SSEyaOC",
	"moreRoot": "_3hNknJhQ7N3OOQOQdSheN0",
	"noIcon": "_1upOrGDy4pVpvaMC9y7z5o"
};